<!-- eslint-disable vue/valid-template-root -->
<script>
import NumInput from "./helpers/NumInput.vue";
import { mapGetters } from "vuex";
import { mapFields } from "vuex-map-fields";
import { scroller } from "vue-scrollto/src/scrollTo";
import LifetimeSliderInput from "@lifetime-gallagher/lifetime-slider-input";
import ToolTip from "./helpers/ToolTip.vue";
import clientConfig from "/src/config/foresters-financial";

import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBBtn,
} from "mdb-vue-ui-kit";

export default {
  name: "AboutPanel",

  components: {
    MDBContainer,
    MDBRow,
    MDBCol,
    MDBBtn,

    LifetimeSliderInput,
    NumInput,
    ToolTip,
  },

  data() {
    return {
      clientConfig,
    };
  },

  computed: {
    ...mapGetters([
      "debugMode",
      "analyticsPageNames",
      "activeTab",
      "lastActiveTab",

      "data",
      "aboutFieldsValid",
    ]),

    ...mapFields([
      "typeOfInvestor",
      "typeOfBond",
      "grossIncome",
      "requiredFuneralFund",
      "targetSavingDuration",
    ]),
  },

  watch: {
    formFieldWatcher: {
      handler() {
        this.$refs.aboutPanel.$el.classList.remove("was-validated");
      },
      deep: true
    },
  },

  methods: {
    validateForm() {
      if (this.checkForm(this.$refs.aboutPanel.$el) && this.aboutFieldsValid) {
        this.clickToTab(3);
      } else {
        const scrollTo = scroller();
        const frm = document.getElementsByClassName("about-page")[0].getElementsByClassName("form-control");
        for (const field of frm) { 
          if (!field.validity.valid) {
            scrollTo("#" + field.id, 300, {offset: -160});
            break;
          }
        }
      }
    },

    checkForm(form) {
      form.classList.add("was-validated");
      return form.checkValidity();
    },

    clickToTab(tabNum) {
      const scrollTo = scroller();
      this.$store.commit("setActiveTab", tabNum);
      scrollTo("#ffApp");

      this.$triggerIframeAnalytics({
        event: "calculator",
        calculator_name: "Investment Forecaster",
        calculator_section: this.analyticsPageNames[this.lastActiveTab],
        calculator_step: tabNum < this.lastActiveTab ? "Back" : "Continue",
      });

      if (this.debugMode)
        console.log(
          "GTM Event: calculator_name: Investment Forecaster, calculator_section: " + 
          this.analyticsPageNames[this.lastActiveTab] + 
          ", calculator_step: " + 
          (tabNum < this.lastActiveTab ? "Back" : "Continue")
        );

      // Pretend this is an onload of the next page
      setTimeout(() => {
        this.$triggerIframeAnalytics({
          event: "calculator",
          calculator_name: "Investment Forecaster",
          calculator_section: this.analyticsPageNames[this.activeTab],
          calculator_step: "Start",
        });

        if (this.debugMode)
          console.log(
            "GTM Event: calculator_name: Investment Forecaster, calculator_section: " + 
            this.analyticsPageNames[this.activeTab] + 
            ", calculator_step: Start"
          );
      }, 100);
    },

  },

  mounted() {},
};
</script>

<template>
  <MDBContainer fluid class="about-page">

    <MDBRow class="p-0 needs-validation" tag="form" novalidate ref="aboutPanel" @submit.prevent>
      <MDBCol class="main-content-wrapper pb-3 mx-auto px-0" col="12" lg="7" md="8" sm="9">

        <MDBRow>
          <MDBCol>
            <div class="form-group about">
              <label for="typeOfInvestor" class="main-label" tabindex="0">
                What type of investor are you?
              </label>
            </div>
          </MDBCol>
        </MDBRow>
        <MDBRow>
          <MDBCol>
            <div class="form-floating mb-4 mb-lg-3">
              <select
                v-model="typeOfInvestor"
                class="form-select form-control"
                name="typeOfInvestor"
                id="typeOfInvestor"
                required
              >
                <option value="">Please select</option>
                <option :value="1">Direct investor</option>
                <option :value="2">Funeral director</option>
                <option :value="3">Adviser</option>
              </select>

              <!-- <label for="typeOfInvestor" v-if="typeOfInvestor != ''">
                Please select
              </label> -->

              <div 
                class="invalid-feedback" 
                aria-live="assertive" 
                aria-description="Please select one of the options."
              >
                Please select one of the options.
              </div>
            </div>
          </MDBCol>
        </MDBRow>

        <MDBRow>
          <MDBCol>
            <div class="form-group about">
              <label for="typeOfBond" class="main-label" tabindex="0">
                Type of bond
              </label>
            </div>
          </MDBCol>
        </MDBRow>
        <MDBRow>
          <MDBCol>
            <div class="form-floating mb-4 mb-lg-3">
              <select
                v-model="typeOfBond"
                class="form-select form-control"
                name="typeOfBond"
                id="typeOfBond"
                required
              >
                <option value="">Please select</option>
                <option :value="1">Investment bond</option>
                <option :value="2">Funeral bond</option>
                <!-- <option :value="3">Education bond</option> -->
              </select>

              <!-- <label for="typeOfBond" v-if="typeOfBond != ''">
                Please select
              </label> -->

              <div 
                class="invalid-feedback" 
                aria-live="assertive" 
                aria-description="Please select one of the options."
              >
                Please select one of the options.
              </div>
            </div>
          </MDBCol>
        </MDBRow>

        <Transition name="fade">
          <div v-show="typeOfBond === 1">
            <MDBRow>
              <MDBCol>
                <div class="form-group about">
                  <label for="grossIncome" class="main-label" tabindex="0">
                    Income (before tax and super)

                    <ToolTip text="The amount you earn before tax and excluding employer super contributions.">
                      <span class="icon-info"></span>
                    </ToolTip>
                  </label>
                </div>
              </MDBCol>
            </MDBRow>
            <MDBRow>
              <MDBCol>
                <NumInput
                  v-model.number.lazy="grossIncome"
                  divClass="rhs"
                  cssClass="input"
                  :options="{
                    precision: { min: 0, max: 0 },
                    valueRange: { min: 50000, max: 5000000 }
                  }"
                  name="grossIncome"
                  label="Enter amount"
                  placeholder="Enter amount per year"
                  :isRequired="typeOfBond === 1"
                  requiredDescription="Please enter a value in this field."
                  requiredMessage="Please enter a value in this field."
                  :addSuffix="true"
                  suffixText="per year"
                />
                <small class="pb-2">
                  <em>Between $50,000 and $5,000,000.</em>
                </small>
              </MDBCol>
            </MDBRow>
          </div>
        </Transition>

        <Transition name="fade">
          <div v-show="typeOfBond === 2">
            <MDBRow>
              <MDBCol>
                <div class="form-group about">
                  <label for="requiredFuneralFund" class="main-label" tabindex="0">
                    Required funeral fund

                    <ToolTip text="Saving amount you need for your funeral fund">
                      <span class="icon-info"></span>
                    </ToolTip>
                  </label>
                </div>
              </MDBCol>
            </MDBRow>
            <MDBRow>
              <MDBCol class="pb-3">
                <NumInput
                  v-model.number.lazy="requiredFuneralFund"
                  divClass=""
                  cssClass="input"
                  :options="{
                    precision: { min: 0, max: 0 },
                    valueRange: { min: 1, max: 30000 },
                  }"
                  name="requiredFuneralFund"
                  label="Enter amount"
                  placeholder="Enter amount"
                  :isRequired="typeOfBond === 2"
                  requiredDescription="Please enter a value in this field."
                  requiredMessage="Please enter a value in this field."
                />
              </MDBCol>
            </MDBRow>

            <MDBRow>
              <MDBCol>
                <LifetimeSliderInput
                  :min='1'
                  :max='30000'
                  v-model='requiredFuneralFund'
                />
              </MDBCol>
            </MDBRow>

            <MDBRow class="mt-5">
              <MDBCol>
                <div class="funeralCost p-3 pb-1">
                  <p>
                    <strong>How much does a funeral cost?</strong>
                  </p>
                  <p>
                    According to the government's <a href='https://moneysmart.gov.au/living-in-retirement/paying-for-your-funeral' target="_blank">Moneysmart website</a>, private funerals typically cost somewhere 
                    in the region of up to $15,000 for an elaborate burial and $4,000 for a basic cremation.
                  </p>
                </div>
              </MDBCol>
            </MDBRow>

            <MDBRow class="mt-4">
              <MDBCol>
                <div class="form-group about">
                  <label for="targetSavingDuration" class="main-label" tabindex="0">
                    Target saving duration

                    <ToolTip text="Approximately when will you need your funeral fund">
                      <span class="icon-info"></span>
                    </ToolTip>
                  </label>
                </div>
              </MDBCol>
            </MDBRow>
            <MDBRow>
              <MDBCol>
                <NumInput
                  v-model.number.lazy="targetSavingDuration"
                  divClass="rhs"
                  cssClass="input"
                  :options="{
                    precision: { min: 0, max: 0 },
                    valueRange: { min: 5, max: 20 },
                    currencyDisplay: 'hidden',
                  }"
                  name="targetSavingDuration"
                  label="Enter amount"
                  placeholder="Enter number of years"
                  :isRequired="typeOfBond === 2"
                  requiredDescription="Please enter a value in this field."
                  requiredMessage="Please enter a value in this field."
                  :addSuffix="true"
                  suffixText="years"
                />
              </MDBCol>
            </MDBRow>
          </div>
        </Transition>

      </MDBCol>
    </MDBRow>
  </MDBContainer>

  <MDBContainer fluid class="px-md-3 mt-4">
    <MDBRow class="px-2">
      <MDBCol md="11" class="main-nav-wrapper">
        <MDBRow>
          <MDBCol md="11" class="mt-3 mb-5 text-center text-sm-start">
            <MDBBtn
              class="btn-primary back mx-3 ms-sm-0 mb-3 mb-sm-0"
              @click="clickToTab(1)"
              aria-label="Back button"
            >
              Back
            </MDBBtn>
            
            <MDBBtn
              class="btn-primary mb-3 mx-3 mx-sm-0 mb-sm-0"
              @click="validateForm"
              aria-label="Continue button"
            >
              Continue
            </MDBBtn>
          </MDBCol>
        </MDBRow>
      </MDBCol>
    </MDBRow>
  </MDBContainer>
</template>
